"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _objectMapper = _interopRequireDefault(require("./objectMapper"));

var createConnector = function createConnector(Consumer) {
  return function (Component, mapper) {
    var Connected = _react["default"].forwardRef(function (props, ref) {
      return _react["default"].createElement(Consumer, null, function (store) {
        return _react["default"].createElement(Component, (0, _extends2["default"])({}, (0, _objectMapper["default"])(store, mapper), {
          ref: ref
        }, props));
      });
    });

    Connected.displayName = "connect(".concat(Component.displayName || '', ")");
    return Connected;
  };
};

var _default = createConnector;
exports["default"] = _default;